import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import type { Dependency } from '../../../../../../../shared/dependenciesV2';
import { useGetDependencyConfidence } from '../../../../../../hooks/api';
import * as DependenciesV2Store from '../../../../../../redux/dependenciesV2';
import List from '../../../../../generic/List';
import DependencyConfidenceBadge from '../../../../../shared/revisions/DependencyConfidence';
import LicensingSection from './LicensingSection';

type Props = {
  // Dependency data from API response
  dependency: Dependency;
};

/**
 * Displays issue and license details for a dependency
 */
const DetailsRow: VoidFunctionComponent<Props> = ({ dependency }) => {
  const scope = useSelector(DependenciesV2Store.selectors.getScope);
  const projectRevision = scope && scope.scope === 'project' ? scope.revision : '';
  const confidence = useGetDependencyConfidence(projectRevision, dependency.locator);

  return (
    <List.RowDetails>
      { confidence !== null && <DependencyConfidenceBadge confidence={confidence} />}
      <LicensingSection
        licenses={dependency.licenses}
        declaredLicenses={dependency.declaredLicenses}
        issues={dependency.issues}
      />
    </List.RowDetails>
  );
};

export default DetailsRow;
